module.exports = __webpack_public_path__ + "static/media/task-assigned-success.dbb37620.svg";